export default {
  main: {
    // 文件
    fileTitle: "Name",
    fileSize: "Size",
    fileDate: "Modification time",
    InquiryId: "InquiryId",
    country: "Country",
    client: "Contacts",
    sales: "Sales",
    date: "Creation Date",
    inquiry: "Inquiry",
    order: "Order",
    sipping: "Sipping",
    pay: "Pay",
    user: "User",
    type: "Type",
    clientGrade: "client grade",
    retail: "retail/wholesale",
    customer: "Customer",
    sell: "Sell",
    status: "Status",
    operator: "Operator",
    myFiles: "My Files",
    FileSharing: "File sharing",
    fileName: "File name",
    password: "Password",
    noPassword: "No password",
    yesPassword: "Share via password",
    expirationTime: "Expiration time",
    cancel: "Cancel",
    define: "Define",
    interlinkage: "interlinkage",
    extractCode: "Extract code",
    createLink: "create link",
    copyAndClose: "Copy and Close",
    newFolder: "New Folder",
    picturePreview: "Picture preview",
    oneHour: "One Hour",
    oneWeek: "One Week",
    oneMonth: "One Month",
    halfAYear: "Half A Year",
    aYear: "One Year",
    newBuilt: "New-built",
    download: "Download",
    delete: "Delete",
    share: "Share",
    rename: "Rename",

    pleaseChoose: "Select",
    pleaseFillIn: "Enter",

    /***order Sales*****/
    SalesOrder: "Sales Order",
    SorderList: "ORDER LIST",
    SorderSeachName: "Enter customer name",
    SorderListSodrderID: "SodrderID",
    SorderListState: "State",
    SorderListItems: "Items",
    SorderListCity: "City",
    SearchCustomersOrders: " SearchCustomersOrders",
    SorderSalesTeam: "TeamMember",
    // 信息选择
    SorderTeam: "Team",
    SorderListClient: "Client",
    SorderListPleaseSelectClient: "Please Select Client",
    SorderListAddress: "Address",
    SorderListSupplier: "Supplier",
    SorderListPleaseSelectSupplier: "Please Select Supplier",
    SorderListDAddress: "Delivery Address",
    SorderListWholesale: "Wholesale",
    SorderListRetail: "Retail",
    SorderListPayment: "Payment",
    SorderListPleaseSelectBank: "Please Select Bank",
    SorderListPleaseSelectCurrency: "Please Select Currency",
    SorderListPleaseSelectOrder: "Please Select Order",
    // 弹窗按钮
    SorderListNewOrder: "NewOrder",
    SorderListSave: "Save",
    SorderListCopyformOrder: "FormOrder",
    SorderListFromRFQ: "FromRFQ", // 原：Form RFQ
    SorderListFromQuotation: "FromQTN", //原： From Quotation
    SorderListClearance: "Clearance",
    SorderListDelete: "Delete",
    SorderListPlaceanorder: "PlaceOrder",
    SorderListDeliverGoods: "DeliverGoods",
    SorderListExport: "Export",
    SorderListCost: "Cost",
    SorderListShipping: "Shipping",
    SorderEntryRecord: "PaymentRecord",
    // 详情
    SorderListDetailModel: "Model",
    SorderListDetailBrand: "Brand",
    SorderListDetailDescription: "Description",
    SorderListDetailState: "State",
    SorderListDetailWeight: "Weight",
    SorderListDetailQty: "Qty",
    SorderListDetailPrice: "Price",
    SorderListDetailProfit: "Profit",
    SorderListDetailCost: "Cost",
    SorderListDetailLeading: "Leading",
    SorderListDetailCondition: "Condition",
    SorderListDetailRelaredDoc: "RelaredDoc",
    SorderListDetailOperation: "Actions",
    SorderListDetailCreateTime: "CreateTime",
    SorderListDetailDelete: "Delete",
    //底部
    SorderListFooterDiscount: "Discount",
    SorderLitFooterShippingCost: "ShippingCost",
    SorderListFooterPaymentFee: "PaymentFee",
    SorderListFooterVat: "Vat",
    SorderListFooterSubtal: "Subtal",
    SorderListFooterTotal: "Total",
    SOrderListFooterPaymentReceived: "PaymentReceived",
    SorderListFooterCost: "Cost",
    // 图表
    SorderListChartPurchase: "Purchase",
    SorderListChartSales: "Sales",
    SorderListChartMon: "Mon",
    SorderListChartTue: "Tue",
    SorderListChartWed: "Wed",
    SorderListChartThu: "Thu",
    SorderListChartFri: "Fri",
    SorderListChartSat: "Sat",
    SorderListChartSun: "Sun",
    // 弹窗组件
    SorderListCopyModelToOrder: "Copy model to order",
    SorderListCopy: "Copy",
    SorderListAdd: "Add",
    SorderListAddModelToOrder: "Add model to order",
    SorderListPleaseEnterRfqID: "Please Enter ID",
    SorderListTotalAmount: "Total Amount",
    SorderListDeclareAmount: "Declare Amount",
    SorderListDeclareName: "Declare Name",
    SorderListDeclareInfo: "Declare Info",
    SorderListDeclarePrice: "Declare Price",
    SorderListFullOrder: "Full order",
    SorderListPartialOrder: "Partial order",
    SorderListDetailHQty: "HQty",
    SorderListDetailPQty: "PQty",
    SorderListPleaseQuantity: "Please enter the quantity ",
    SorderListPurchaser: "Purchaser",
    SorderListFullDelivery: "Full delivery",
    SorderListPartialDelivery: "Partial delivery",
    SorderListSQty: "SQty",
    SorderListPqty: "PQty",
    SorederListExport: "Export",
    SorderListScheduledGoods: "ScheduledGoods",
    SorderListExitNewOrder: "ExitNewOrder",
    // order Puchase
    PurchaseOrder: " Purchase Order",
    PurchaseOrderPurchase: "Select Purchase",
    PurchaseOrderTakeList: "PURCHASE TAKE LIST",
    PurchaseOrderTakeListPtaskID: "Ptask ID",
    PurchaseOrderTakeListState: "State",
    PurchaseOrderTakeListSales: "Sales",
    PurchaseOrderTakeListPurchase: "Purchase",
    PurchaseOrderTakeListPurchase1: "ChoosePurchase",
    PurchaseOrderTakeListCreationTime: "CreationTime",
    PurchaseOrderTakeDetailDQty: "DQty",
    PurchaseOrderTakeDetailFqty: "Fqty",
    PurchaseOrderTakeDetailInventory: "Inventory",
    PurchaseOrderTakeDetailAvailable: "Available",
    PurchaseOrderTakeDetailOccupy: "Occupy",
    PurchaseOrderTaleDetailreturnTask: "returnTask",
    PurchaseOrderList: "PURCHASE ORDER LIST",
    PurchaseOrderListPorderID: "PorderID",
    PurchaseOrderListSupplier: "Supplier",
    PurchaseOrderListFounder: "Founder",
    PurchaseOrderListDetailTotal: "Total",
    PurchaseOrderListDetailPqty: "Pqty",
    PurchaseOrderListDetailPrice: "Price",
    PurchaseOrderButtonNew: "New",
    PurchaseOrderButtonAssignTasks: "AssignTasks",
    PurchaseOrderButtonSubmitTask: "SubmitTask",
    PurchaseOrderButtonDelete: "Delete",
    PurchaseOrderButtonChangePrice: "ChangePrice",
    PurchaseOrderBUttonSubmitPrice: "SubmitPrice",
    PurchaseOrderButtonExport: "Export Porder",
    PurchaseOrderButtonDel: "Delete",
    PurchaseOrderNewPurchaseOrder: "NewPurchaseOrder",
    PurchaseOrderSelectSupplier: "Select supplier",
    PurchaseOrderNonStock: "Non-Stock",
    PurchaseOrderNewPqty: "PQty",
    PurchaseOrderNewCost: "Cost",
    PurchaseOrdernewAvailableQty: "InventoryQty",
    PurchaseOrderNewAvailablePrice: "InventoryPrice",
    PurchaseOrderNewInventoryPrift: "InventoryPrift",
    PurchaseOrderExportRate: "rate",
    PurchaseOrderExportSprice: "Price",
    PurchaseOrderExportAmountProfit: "AmountProfit",
    PurchaseOrderExportAmount: "Amount",
    PurchaseOrderExportNumber: "Number",
    PurchaseOrdering: "In procurement",
    PurchaseCommission: "AddCommission",
  },
  // 消息模块
  message: {
    Mymessage: "My Message",
    MessageSettings: "Message Settings",
    Read: "Read",
    newTemplate: "Create Message Template",
    OrderMessage: "Ticket Message",
    SystemMessages: "System messages",
    EventType: "Event Type",
    ContentTemplate: "Content Template",
    MessageContent: "Message Content",
    state: "Status",
    PushMethod: "Push Method",
    PushTime: "Push Time",
    PushNow: "Push Now",
    exceed: "Exceed",
    HourlyPush: "Hourly push",
    founder: "Creator",
    priority: "Priority",
    ordinary: "Ordinary",
    emergent: "Emergent",
    ReceptionTime: "Creation Date",
    Creationtime: "Creation Date",
    operate: "Action",
    WorkOrder: "Detail",
    edit: "Edit",
    Enable: "Enable",
    Deactivate: "Disable",
    Enabled: "Enabled",
    Disabled: "Disabled",
    editTemplate: "Edit Message Template",
    save: "Save",
    messageType: "Message Type",
    MessageTemplate: "Message Template",
    cancellation: "Cancel",
    EnableStatus: "Status",
    sitePush: "On site push",
    textMmessage: "Text Message",
    orderExceeds: "Work order exceeds",
    orderContent: "Hours unresolved, push message reminder",
    interval: "interval",
    Pushonceperhour: "Push once per hour",
    PushObject: "Push Recipient",
    Receiver: "Assignee",
    promoter: "Initiator",
    CcTo: "Cc Recipient",
    OrderDetails: "Work Order Details",
    close: "Close",
    ToHandle: "To handle",
    InitiateWorkOrder: "Initiate Work Order",
    source: "Source",
    describe: "Describe",
    loading: "Loading",
    notExist: "Work order deleted",

    AllTypes: "All Types",
    AllRead: "All Read",
    Messages: "Messages",
    enabledSuccessfully: 'Template enabled successfully',
    disabledSuccessfully: 'Template Disabled successfully',
    SaveSuccessfully: 'Save successfully',
    Type: 'Type',
    KeyWords: 'Key Words',
    EnabledTitle: 'Are you sure to enabled it?',
    DisabledTitle: 'Are you sure to disabled it?',
    EventTypeRule: 'Please select an event type',
    ContentRule: 'Content cannot be empty',
    PushTimeRule: 'Please select the push time',
    PushObjectRule: 'Please select the push object',
    PushMethodRule: 'Please select a push method',

  },
  //订单
  Order: {
    OrderAll: 'All',
    OrderMy: 'My',
    salesOrder: 'Sales Orders',
    salesOrder1: 'Sales Order',
    salesOrder2: 'Commission Sales Order',
    salesOrder3: 'After-sales Reshipment Order',
    sOrderTypeWholesale: 'Wholesale',
    sOrderTypeRetail: 'Retail',
    sOrderTypecommission: 'Commission',
    sOrderAllstatus: 'All Statuses',
    sOrderStateTobestarted: 'Pending Start',
    sOrderStateUnderway: 'In Progress',
    sOrderStateCompleted: 'Completed',
    sOrderStateAllocationorder: 'Pending Allocation Orders',
    sOrderStateOnassignment: 'Pending Shipment Allocation',
    sOrderStateGeneraldelivery: 'Pending Facilities Department Shipment',
    sOrderStateLogisticsdocumentary: 'Pending Logistics Follow-up',
    sOrderStateIncoming: 'Pending Arrival Verification',
    SorederListExport: "Export",

    pOrderStateTobepurchased: 'Pending Purchase',
    pOrderStateInprocurement: 'In Progress',
    pOrderStatePurchasecompleted: 'Purchase Completed',
    pOrderStateTobepaid: 'Pending Payment',
    pOrderStatePaid: 'Paid',
    pOrderStateWaitingforarrival: 'In Transit',
    pOrderStatePurchasecompleted: 'Purchase Completed',
    pOrderIndex: 'Number',
    PurchaseOrderPOID: 'POID',
    PurchaseOrderTotal: 'Total',
    PurchaseOrderProfit: "AmountProfit",

    OrderNew: 'New',
    OrderFromOrder: 'From Order',
    OrderFromRFQ: 'From RFQ',
    OrderFromQTN: 'From QTN',
    OrderClearance: 'Clearance',
    OrderPlaceanorder: "Order Allocation",
    OrderDeliver: "Shipment Allocation",
    OrderListCost: "Purchase Records",
    OrderListShipment: "Shipment Records",
    OrderExtraSearch: 'Extra Search',
    OrderSettle: 'Settle',
    OrderSettlementDetails: 'Settlement Details',

    OrderOwner: 'Owner',
    OrderSOID: 'SO ID',
    OrderCarrier: 'Carrier',
    OrderCreator: 'Creator',
    OrderSubject: 'Subject',
    OrderTableContact: 'Contact',
    OrderTableCountry: 'Country/Region',
    OrderTableItems: 'Items',
    OrderTableType: 'Type',
    OrderTableSales: 'Sales',
    OrderTableStatus: 'Status',
    OrderTableCreatedDate: 'Creation Date',

    OrderCreated: 'Created',
    OrderApprove: 'Approved',
    OrderTraded: 'Traded',
    OrderStateCancel: 'Cancelled',
    OrderAllStatus: 'All Statuses',
    OrderAllType: 'All Type',
    OrderAllVendor: 'All Vendor',
    OrderAllContatc: 'All Contatc',
    OrderAllCountries: 'All Countries',
    OrderAllModels: 'All Models',
    OrderPurchaseOrder: 'Purchase Order',

    OrderTableModel: "Model",
    OrderTableBrand: "Brand",
    OrderTableDescription: "Description",
    OrderTableWeight: "Weight",
    OrderTableQty: "Qty",
    OrderTableQty1: "Qty",
    OrderTablePrice: "List Price",
    OrderTableProfit: "Profit",
    OrderTableCost: "List Cost",
    OrderTableLeading: "Leading",
    OrderTableCondition: "Condition",
    OrderTableDeclareName: "Declare Name",
    OrderTableDeclareInfo: "Declare Info",
    OrderTableDeclarePrice: "Declare Price",
    OrderTableAllotmentQty: 'Allocated QTY',
    OrderTablePartialQty: 'Partial QTY',
    OrderTableAlreadyOrderedQty: 'Allocated QTY',
    OrderTableShippedQty: 'Shipped QTY',
    OrderTablePartialShipmentQty: 'Partial Shipment QTY',

    OrderDiscount: "Order Discount",
    OrderShippingCost: "Shipping Fee",
    OrderPaymentFee: "Processing Fee",
    OrderTax: "Tax Fee",
    GrandTotal: "Grand Total",
    SubTotal: "Subtotal",

    OrderVendor: "Vendor",
    OrderContact: "Contact",
    OrderPay: "Pay",
    OrderPayment: "Payment",
    OrderNewPayment: "New Payment",
    OrderPayment1: "Pay",
    OrderPayBank: 'PayBank',
    OrderCurrency: "Currency",
    OrderRate: "Rate",
    OrderPayInfo: "Payment Info",
    OrderAddress: 'Address',
    OrderBuyer: 'Buyer',
    OrderSelect: 'Select',
    OrderEnter: 'Enter',

    OrderSave: 'Save',
    OrderCancel: 'Cancel',
    OrderDelete: 'Delete',
    OrderOutput: 'Output',
    OrderSaveandNew: 'Save and New',

    OrderTotalAmount: 'TotalAmount',
    OrderTotalDeclareAmount: 'DeclareAmount',
    OrderFullOrder: "Full Order",
    OrderPartialOrder: "Partial Order",
    OrderFullDelivery: "Full Delivery",
    OrderPartialDelivery: "Partial Delivery",

    OrderChartPurchase: "Cost",
    OrderChartPurchase1: "Purchase Cost",
    OrderChartSales: "Price",
    OrderChartSales1: "SalesPrice",
    OrderChartMon: "Mon",
    OrderChartTue: "Tue",
    OrderChartWed: "Wed",
    OrderChartThu: "Thu",
    OrderChartFri: "Fri",
    OrderChartSat: "Sat",
    OrderChartSun: "Sun",

    OrderExpenditureRecord: 'Expense Records',
    OrderPaymentRecords: 'Payment Records',

    PorderPurchaser: 'Purchaser',
    PorderSuppliers: 'Suppliers',
    PorderCreatedBy: 'Creator',
    PorderAllocate: 'Reallocate Task',
    PorderInventory: 'Inventory QTY',
    PorderAvailable: 'Available QTY',
    PorderOccupy: 'Occupied QTY',
    PorderAllocatePurchaser: 'AllocatePurchaser',
    PorderAllocateQty: 'Allocate Qty',
    PorderAlterCost: 'Alter Cost',
    SorderID: 'Sorder ID',
    PorderToal: 'Total',
    PorderStock: 'Stock',
    PorderPurchaseQty: 'Purchase Qty',
    PorderPurchaseTotal: 'Purchase Total',
    PorderStockQty: 'Inventory Qty',
    PorderStockPrice: 'InventoryPrice',
    PorderInventoryProfit: 'Inventory Profit',
    PorderAction: 'Action',
    PorderInputPrice: 'IPrice',
    ReverseMonthly: 'Reverse Monthly',
    ReverseSettlement: 'Reverse Settlement',
    ReverseOrders: ' Reverse Settled Orders',
    orderYes: 'Yes',
    orderGrossProfit: 'Gross Profit',
    orderMonth: 'Month',
    orderYear: 'Year',
    orderSettlementID: 'Settlement ID',
    orderEarliestOrder: 'The Earliest Order',
    orderLastOrder: 'The Last Order',
    orderTotalIncome: 'Total Income',
    orderTotalExpenditure: 'Total Expenditure',
    orderProfit: 'Profit',
    orderProfitIs: 'The profit is',
    orderCreationTime: 'Creation Time',
    order_Remarks: 'Order Remarks',
    orderWay: 'Way',
    orderPaied: 'Paied',
    orderReceiveTime: 'Received Time',
    orderPaymentType: 'Payment Type',
    orderReceivedRate: 'Received Rate',
    orderSaleType: 'Type',
    orderSaleAmount: 'Amount',
    orderSaleCreator: 'Creator',
    orderSaleCreationDate: 'Creation Date',
    orderStage: 'Stage',
    orderUpdatedBy: 'Updated By',
    orderUpdatedDate: 'Updated Date',
    orderTableDiscount: 'Discount',
    orderTableTax: 'Tax',
    orderTableTotal: 'Total',
    orderTips: 'Tips',
    orderApprover: 'Are you sure to approve this order?',
    orderTipsInfo1: `1. The model information cannot be edited after approved;\n2. After approval, you can add, edit, or delete newly added models;\n3. After approved, the vendor will receive the order in the system.`,
    orderTraded: 'Is the order confirmed as traded?',
    orderTipsInfo3: `After the order status is "Traded", you can add, edit, or delete newly added models.`,
    orderCancelled: 'Is the order confirmed as cancelled?',
    orderTipsInfo4: `After the order status is "Cancelled", you can add, edit, or delete newly added models.`,
    orderTipsNo: 'No',
    orderTipsYes: 'Yes',
    orderDetail: 'Details',
    orderBrief: 'Brief',
    orderItems: 'Items',
    orderStart: 'START',//Start
    orderClosing: 'CLOSING',//Closing 
    orderFee: 'Fee',
    orderHistory: 'Historical Price',
    orderPayRef: 'Pay',
    orderAfterSale: 'After-sales',
    orderSlack: 'Slack',
    orderBriefInformation: 'Brief Information',
    orderShopingInformation: 'Shoping Information',
    orderCRMInformation: 'CRM Information',
    orderOriginalOrder: 'Original Order',
    orderOriginal: 'Original',
    orderCreateSalesOrder: 'Create Sales Order',
    orderItemsInformation: 'Items Information',
    orderSelectTheContacts: 'Select The Contacts',
    orderSelectTheAddress: 'Select The Address',
    orderSelectTheVendor: 'Select The Vendor',
    orderSelectTheCurrency: 'Select The Currency',
    orderRATE: 'RATE',
    orderSelectThePayment: 'Select The Payment',
    orderSelectTheBank: 'Select The Bank',
    orderEditSalesOrder: 'Edit Sales Order',
    orderSelectThePurchaser1: 'Select The Purchaser',
    orderFromSalesOrder: 'From Sales Order',
    orderFromPurchaseOrder: 'From Purchase Order',
    orderSelectTheOrder: 'Select The Order',
    orderAvailable: 'Available',
    orderSeletedItems: 'Seleted Items',
    orderSelected: 'Selected',
    orderFromContactsQTN: "From Contact's QTN",
    orderSelectTheContactsQTN: "Select The Contact's QTN",
    orderSelectContact: 'Select The Contact',
    orderSelectCountry: 'Select The Country/Region',
    orderSelectType: 'Select The Type',
    orderSelectTypeOrder: 'Select The Form',
    orderSelectStatus: 'Select The Status',
    orderSelectModel: 'Select The Model',
    orderSelectBuyer: 'Select The Buyer',
    orderStartDate: 'Start date',
    orderEndDate: 'End date',
    orderDateTo: 'To',
    orderKeyWords: 'Key Words',
    orderFromContact1: 'From Contact',
    orderPast7Days: 'Past 07 Days',
    orderPast30Days: 'Past 30 Days',
    orderPast90Days: 'Past 90 Days',
    orderPurchaserTasks: 'Purchase Tasks',
    orderSearchTakeList: 'Search the purchase tasks',
    orderSelectSales: 'Select The Sales',
    orderSelectPurchasers: 'Select The Purchasers',
    orderPurchaserOrders: 'Purchase Orders',
    orderSearchPurOrderList: 'Search the purchase orders',
    orderCreatePurchaseOrder: 'Create  Purchase Order',
    orderConfirm: 'Confirm',
    orderInventoryPrice: 'Inventory Price',
    orderInventoryQty: 'InventoryQty',
    orderPurchasePice: 'Cost',
    orderAccess: 'AccessQty',
    orderTaskItems: 'Purchase Task Items',
    orderPurchaserOrdersItems: 'Purchase Order Items',
    orderAllPurchase: 'All Purchase',
    orderAllSale: 'All Sales',
    orderAllVendor: 'All Vendor',
    orderSpec: 'Spec',
    orderSettledList: 'Settled Order List',
    orderSettledOrders: 'Settled Orders',
    orderMonthlyProfit: 'Monthly Profit',
    orderSettlementIDProfit: 'Settlement ID Profit',
    orderReverse: 'Reverse',
    orderPIName: 'orderName',
    orderLoading: 'Loading...',
    orderSalesOrders: 'Sales Orders',
    orderAll: 'All',
    orderMy: 'My',
    orderGrossProfit: 'Gross Profit',
    orderMyUnsettledOrders: 'My Unsettled Orders',
    orderMySettledOrders: 'My Settled Orders',

    orderFromErrorInfo: 'Please ensure that the information is complete and in an accurate format',
    orderNopermission: 'No permission, please contact the administrator',
    orderDelInfo: 'Are you sure to delete the selected data?',
    orderPlaceSelectStatus: 'Please select status',
    orderProductDelete: 'Please select the product you want to delete',
    orderStatusSeleted: "This status cannot be selected",
    orderNewAddress: "New Address",
    orderMarked: "Mark the current status",
    orderNoItems: "No items selected",
    orderSelectItem: "Select an item from Items a start using it",
    orderReverseMonthly: 'Sure to Reverse Settlement these Monthly statement?',
    orderReverseMonthlyItem: 'Sure to Reverse Settlement this Monthly statement?',
    orderReverseSettlement: 'Sure to Reverse Settlement these Settlement ID?',
    orderReverseSettlementItem: 'Sure to Reverse Settlement this Settlement ID?',
    orderReverOrder: 'Sure to Reverse Settlement these orders?',
    orderReverOrderItem: 'Sure to Reverse Settlement this orders?',
    orderSelectCopyProduct: 'Please select the product you want to copy',
    orderSelectDeleteProduct: 'Please select the product you want to delete',
    orderAgainSubmit: 'Please do not submit again',
    orderPleaseAddData: 'Please add data',
    orderSelectShipOrder: 'Please select the order you want to ship',
    orderLockedDeleted: 'The order is locked and cannot be deleted',
    orderReplication: 'Successful replication',
    orderPleaseSelectPurchaseOrder: 'Please select the purchase order you want to delete',
    orderPleasePurchaseTask: 'Please select the purchase task that you want to delete',
    orderEnterQuantityPrice: 'Enter quantity of stock to get average price',
    orderPleaseNumber: 'Enter Number ',
    orderInventoryQtyAccessQty: "The  'InventoryQty ' does not match the of 'AccessQty'",
    orderAvailablePurchase: 'There is no quantity available for purchase in this batch',
    orderSureReturn: 'Sure to return the selected product?',
    orderSureDistribute: 'Sure to distribute the selected product?',
    orderSureDeleteProduct: 'Sure you want to delete the selected product?',
    orderAccurate: 'Please ensure that the price has been re-entered and the format is accurate',
    orderChangeProduct: 'Sure to change the price of the selected product?',
    orderPleaseEnterTask: 'Please select the purchase task to enter',
    orderTaskReassigned: 'This task is already being purchased and cannot be reassigned',
    orderSelectAssigned: 'Please select the product to be assigned',
    orderAllocationSuccess: 'Allocation success',
    orderProcurementReturnable: 'The task is in the process of procurement, no returnable quantity',
    orderPleaseProductReturn: 'Please select the product to return',
    orderReturnSuccessful: 'Return successful',
    orderPleaseChangedPrice: 'Please select the product for which the price is changed',
    orderChangesuccessfully: 'Change successfully',
    orderPurchaseCannotDeleted: 'The purchase order has been paid for and cannot be deleted',
    orderPleaseDeleteProduct: 'Please select the product you want to delete',
    orderSuccessfullyDeleted: 'Successfully deleted',
    orderSelectDelData: 'Please select the data you want to delete',
    orderEnterOnlyTwo: 'Enter two decimal places only',
    orderGreaterCannot: 'The input data cannot be greater than',
    orderSureSett: 'Sure to settle these orders ?',
    orderTips: 'Tips',
    orderNewInformation: 'New information not been saved yet, Are you sure to leave ?',
    orderEditInformation: 'Edited information not been saved yet, Are you sure to leave ?',
    orderInformation: 'information not been saved yet, Are you sure to leave ?',
    orderConfirm: "Confirm",
    orderCancel: "Cancel",
    orderSelectContactPI: "Select a contact to obtain the PI",
    orderPleaseAmount: 'Please enter the amount',
    orderCommission: 'Commission',
    orderRelatedPI: 'Related PI',
    orderUndertaker: 'Undertaker',
    orderPleasePI: 'Please select order to get PI',
    orderPreviousAmount: 'Previous Amount',
    orderUpdatedAmount: 'Updated Amount',
    orderUpdater: 'Updater',
    orderUpdatedDate1: 'Updated Date',
    orderTypeOrder: 'Order Form', //Order Type
    orderSalesOrderNormal: 'Sales Order',
    orderCommissionSalesOrder: 'Commission Sales Order',
    orderAftersaleReshipment: 'After-sales Reshipment Order',
    CreateNewOrder: 'Create New Order',
    orderNextStep: 'Next Step',
    CreateCommissionSalesOrder: 'Create Commission Sales Order',
    CreateAftersalesReshipmentOrder: 'Create After-sales Reshipment Order',
    OrderFee: 'Fee',
    EditCommissionSalesOrder: 'Edit Commission Sales Order',
    EditAftersalesReshipmentOrder: 'Edit After-sales Reshipment Order',
    RelateAfterSalesReshipmentOrder: 'Related After-sales',
    ROrder: 'R Order',
    RelateSalesOrder: 'Relate Sales Order',
    OrderType1: 'Form',
    InputDataCannot: 'Input data cannot be greater than',
    EnterSubject: 'Enter Subject',
    SelectTheCarrier: 'Select The Carrier',
    SelectThePurOrder: 'Select The Purchase Order',
    ProductionDate: 'Production Date',
    FreightSpace: 'Freight Space',
    EditPurchaseOrder: 'Edit Purchase Order',
    PurchaseOrders: 'Purchase Orders',
    PurOrderLogs: 'Logs',
    PurOperator: 'Operator',
    PurOperationTime: 'Operation Time',
    OperationContent: 'Operation Content',
    PurActionInfo1: 'List Cost Updated From',
    PurActionInfo2: 'To',
    PurchaserOrdersLog: 'Purchaser Orders Log',
    SurfaceMail: 'Surface Mail',
    Register: 'Register',
    EMSExpress: 'EMS Express',
    FederalExpress: 'Federal Express',
    UPSExpress: 'UPS Express',
    OrderCity: 'City',
    OrderZip: 'Zip',
    OrderBankName: 'Bank Name',
    OrderDepositBank: 'Deposit Bank',
    OrderBankAccount: 'Bank Account',
    OrderBalance: 'Balance',
    OrderCompany: 'Company',
    OrderNoncollectableCountries: 'Non-collectable countries',
    AddToOrder: 'Add To Order',
    NewOrder: 'NewOrder',
    VendorContanct: 'Vendor Contanct',
    orderSetDiscount: 'Set Discount',
    orderDiscountPercentage: 'Discount Percentage',
    orderDirectReduction: 'Direct Reduction',
    orderSetTax: 'Set Tax',
    orderConsumptionTax: 'Consumption Tax',
    orderValueAddedTax: 'ValueAdded Tax',
    orderTariff: 'Tariff',
    orderTotal: 'total',
    orderExactSearch: 'Exact Search',
    orderReset: 'Reset',
    orderSearch: 'Search',
    orderFollowingCancelled: 'The following statement has been cancelled',
    orderOrderCreated: 'Order Created',
    PurchaseOrderCreated: 'Purchase order Created',
    orderIsLocked: 'The order is locked and cannot be deleted',
    OerderWarningDel: "Confirm deletion of this order?",
    OrderNchanged: 'The data remains unchanged',
    SettlementSuccessful: 'Settlement Successful',
    Source: 'Source',
    SelectTheSources: 'Select The Source',
    ContactOwner: 'Contact Owner',
    SelectTheContactOwner: 'Select The Contact Owner',
    orderFrom: 'From',
    orderClose: 'Close',
    TotalRevenue: 'Total Revenue',
    TotalExpenses: 'Total Expenses',
    TotalProfit: 'Total Profit',
    SupplySource: 'Supply Source',
    AddNewProduct: 'Add New Product',
    ProductName: 'Product Name',
    DescriptionName: 'Description Name',
    Description: 'Description',
    Language: 'Language',
    Commission: 'Commission',
    OrderNoData: 'No Data',
    OrderProfit: 'Order Profit',
    Account: 'Account',
    ProductProfit: 'Product Profit',
  },
  Warning: {
    OrderWarning: "Warning",
    OrderWarningCancel: "Cancel",
    OrderWarningOK: "OK",
  },

  success: {
    OrderSaveSuccess: "Saved Successfully",
    OrderAddedSuccess: "Successfully Added",
    OrederDeletedSuccess: "Successfully Deleted",
    OrderSuccessSuccessPlaceAnOrder: "Order Placed Successfully",
    OrderSuccessDelivery: "Shipment Sent Successfull",
    PurchaseOrderSuccessDeployment: "Successfully Allocated",
    PurchaseOrderSuccessfulReturn: "Return Processed Successfully",
    PurchaseOrderSuccessChange: "Successfully Changed",
    PaymentAuditSuccess: "Approval Successful",
    SubmissionSuccessful: "Submission Successful",
    WithdrawalSuccessful: "Withdrawal Successful",
    RejectionSuccessful: "Rejection Successful",
  },
  /**询盘**/
  rfq: {
    warning: "Warning",
    newWarning:
      "Creating a new one will result in the loss of unsaved data. Do you want to save and create a new one?",
    noSave: "No need to save",
    new: "New",
    cancelNew: "Cancel New",
    save: "Save",
    addOrder: "Add to Order",
    addQuotation: "Add to QTN",
    delete: "Delete",
    multipleBuyer: "MultipleBuyer",
    quoter: "Quoter",
    operation: "Operation",
    rfqId: "RFQ ID",
    cnty: "Country/Region",
    items: "Items",
    supplier: "Supplier",
    status: "Status",
    add: "Add",
    savePrompt: "Please select a model and brand first",
    saveSuccess: "Save Successful",
    delSuccess: "Successfully Delete",
    deleteWarning: "Sure to delete?",
    historicalInquiry: "Historical inquiry",
    historicalQuote: "Historical Quote",
    fromRfq: "From RFQ",
    excel: "Excel",
    historicalDeal: "Historical Transaction Prices",
    rfqList: "RFQ LIST",
    qtnList: "QTN LIST",
    chooseTheOrder: "Please select the order",
    toQuote: "Adding Items to a Quote",
    batchProfit: "Batch change profit",
    batchDeliveryDate: "Batch change of delivery date",
    pleaseInquiry: "Please select an inquiry",
    pleaseOrder: "Please select the order",
    leading1: "+1 week",
    leading2: "+3 mouth",
    leading3: "+1 day",
    leading4: "+3 day",
    leading5: "+5 day",
    leading6: "+1 mouth",
    leading7: "+6 mouth",
    condition1: "New Sealed Under Guarantee",
    condition2: "New Sealed Beyond Guarantee",
    condition3: "New Unsealed Under Guarantee",
    condition4: "New Unsealed Beyond Guarantee",
    condition5: "Refurbish",
    condition6: "Used",
    condition7: "Substitute",
    condition8: "High Copy Blank Brand",
    condition9: "High Copy With Brand",
    condition10: "Upgrade",
    condition11: "Discontinued",
    exportWarning: "Please select an offer",
    draft: "Draft",
    quoting: "Quoting",
    Quoted: "Quoted",
    pending: "Pending",
    salesRecord: "Sales Recorded",
    purchaserRecord: "Purchaser Recorded",
    contactsQtn: "Contact‘s QTN",
    completedUnread: "Completed Unread",
    completed: "Completed",
    read: "Read",
    sendQtn: "Send QTN",
    notSelected: "No items selected",
    selectAnItem: "Select an item from Items to start using it.",
    contact: " Contact",
    accout: "Account",
    saveAndNew: "Save and new",
    cancelTheNew: "cancel the new",
    text: "Text",
    allStatuses: "All",
    checkWant: "Select the content to export",
    replicated: "Replicated",
    tips: "Tips",
    editedInformation:
      "Edited information not been saved yet. Are you sure to leave?",
    clipboard: "Clipboard",
    PleaseSelectInquiry: "Please select the inquiry that needs to be processed",
    formatError: "format error",
    dataError:
      "This model does not exist. Please enter the model library first before adding it",
    pasteSuccessful: "Paste success",
    ensureThat:
      "Please ensure that the information entered is complete and formatted accurately",
    paste: "From Quick Paste",
    pleasePaste: "Please paste",
    copySpecification:
      "Copy specifications:model x quantity, case:PC/MPI x 12.",
    copyingTheModel:
      "After copying the model and quantity, click on the 'From Quick Paste' operation to quickly create the corresponding Items data.",
    multipleModels: "Use the enter key to wrap multiple models.",
    orderFirst: "Please select an existing order first",
    QTNFirst: "Please select an existing QTN first",
    cannotBe0: "Price cannot be 0",
    maxQty: "Maximum quantity 999999",
    maxCost: "Cost limit 9999999999.99",
    maxRrice: "Price limit 9999999999.99",
    maxProfit: "Profit limit 9999999999",
    accurate:
      "Please enter a positive number or zero, accurate to two decimal places",
    vendor: "Vendor",
    submitToQtn: "Submit To QTN",
    submitToVendo: "Submit To Vendo",
    addToQtn: "Add To QTN",
    listPrice: "List Price",
    amount: "Amount",
    send: "Send",
    arrivalTime: "Arrival time",
    selectCountry: "Please select country",
    Creator: "Creator",
    allContacts: "All Contacts",
    allCountrys: "All Countries/Regions",
    selectTheModel: "Select The Model",
    start: "START",
    closing: "CLOSING",
    items: "Items",
    teamItem: "Team Items",
    creationDate: "Creation Date",
    originalRfq: "Original RFQ",
    cancel: "Cancel",
    confirm: "Confirm",
    createNewRfq: "Create New RFQ",
    resubmit: "Please do not resubmit",
    briefInformation: "Brief Information",
    itemsInformation: "Items Information",
    cannotBeEmpty: "Items cannot be empty.",
    astp: "After submission, the purchaser can review and quote for you.",
    astpVendor: "After submission, the vendor can review and quote for you.",
    Submit: "Submit",
    submitTo: "Submit To ",
    purchaser: "Purchaser",
    qtn: "QTN",
    purchaseQtn: "Related Purchase QTN",
    fromPurchaseQtn: "From Purchase QTN",
    quoteToSales: "Quote To Sales",
    quoteToContacts: "Quote To Contacts",
    sendTheQtnSales: "Are you sure to send the QTN to the Sales?",
    sendTheQtnContact: "Are you sure to send the QTN to the Contact?",
    send: "Send",
    SendQuote: "Send Quote",
    historyQTN: "Historical QTN",
    historyDealValence: "Historical Transaction Prices",
    NoItemsSelected: "No items selected",
    SelectNnItemFrom: "Select an item from Items to start using it.",
    SelectTheRFQ: "Select The RFQ",
    Available: "Available",
    SelectedItems: "Selected Items",
    QuicklyAddQTN: "Quickly add QTN to the RFQ.",
    ThePublicRFQ: "The Public RFQ",
    PublicRFQ: "Public RFQ",
    PersonalRFQ: "Personal RFQ",
    AvailableItems: "Available Items",
    myQTN: "My QTN",
    AddToOrder: "Add To Order",
    QuicklyAddRFQ: "Quickly add the RFQ to a Order.",
    SelectExistingOrder: "Select Existing Order",
    Selected: "Selected",
    RelatedQTN: "Related QTN",
    RelatedContactsQTN: "Related Contact's QTN",
    Sales: "Sales",
    CreateNewOrder: "Create New Order",
    ListPrice: "List Price",
    SelectTheCurrency: "Select The Currency",
    SelectTheProfit: "Select The Profit",
    KeyWords: "Key Words",
    noDataToSubmit: "There is no data to submit",
    networkError: "Network error",
    submitted: "Submitted",
    modelToBeQuoted: "Please select the model to be quoted first",
    hasBeenSelected: "The inquiry has been selected and cannot be added again",
    alreadyExists: "Already Exists",
    selectTheVendor: "Select The Vendor",
    selectThePurchaser: "Select The Purchaser",
    pleaseSelectRFQ: "Please Select RFQ",
    ModifiedSuccessfully: "Modified Successfully",
    NoData: "No Data",
    submitToVendor: "Submit To Vendor",
    addToPurchaseOrder: "Add To Purchase Order",
    selectTheVendorAndRFQ: "Select The Vendor And RFQ",
    spec: "Spec",
    pleaseselectInquiry: "Please select Inquiry",
    allVendor: "All Vendor",
    submitToContact: "Submit To Contact",
    addToSalesOrder: "Add to Sales Order",
    selectPurchaser: "Select Purchaser",
    replicatingSuccess: "Replicating Success",
    noData: "No Data",
    select: "Select",
    selectTheCountry: "Select The Country/Region",
    selectTheAccount: "Select The Account",
    startDate: "Start Date",
    endDate: "End Date",
    selectTheModel: "Select The Model",
    search: "Search",
    reset: "Reset",
    exactSearch: "Exact Search",
    my: 'My',
    all: 'All',
    publicRFQ: 'Public RFQ',
    personalRFQ: 'Personal RFQ',
    myRFQ: 'My RFQ',
    contactsRFQ: "Contact's RFQ",
    myQTN: 'My QTN',
    PurchaseQTN: 'Purchase QTN',
    ContactsQTN: "Contact's QTN",
    RFQ: 'RFQ',
    QTN: 'QTN',
    PleaseChoose: 'Please Choose',
    PleaseselectContact: 'Please select Contact',
    PleaseselectOwner: 'Please select Owner',
    PleaseselectSupplier: 'Please select Supplier',
    InStock: 'In Stock',
    OutStock: 'No',
    yesAvailable: 'Yes',
    OutOfStock: 'Out of stock',
    averagePrice: 'Average Price',
    myPrice: 'My Prices',
    source: 'Source',
    RFQCreated: 'RFQ Created',
    PleaseSelectOperatedData: 'Please select the data that needs to be operated on first',
    allBrands: 'All Brands',
    rfqId: 'RFQ ID',
    PleaseSelectRfqID: 'Please select RFQ ID',
    orderID: 'Order ID',
    PleaseSelectOrderID: 'Please select Order ID',
    quotedIsNotSupportedDeletion: 'This model has been quoted and cannot be deleted.',
    AllVendors: 'All Vendors',
    AllConditions: 'All Conditions',
    maxPrice: 'Max Price',
    minPrice: 'Min Price',
    creationTime: 'Creation Date',
    models: 'Models',
    action: 'Action',
    targetedRfq: 'Targeted RFQ',
    AddNewProduct: 'Add New Product',
    PublicScope: 'Public Scope',
    AllPlatformVendors: 'All Platform Vendors',
    MyVendors: 'My Vendors',
    QrganizationVendors: "Qrganization's Vendors",
    Description: 'Description',
    EnterTheDescription: 'Enter the description',
    ModelsSubmitted: 'Models Submitted',
    AllPrices: 'All Prices',
    Favorite: 'Favorite',
    Canceled: 'Canceled',
    detail: 'Detail',
    added: 'Added',
    AllPublicScope: 'All public scope',
    To: 'To',
    LastWeek: 'Last week',
    LastMonth: 'Last month',
    Last3Months: 'Last 3 months',
    OutOfStockNotAddition: 'Out of stock not supported for addition',
    enter: 'Enter',
    Tips: 'Tips',
    ItemsCannotEmpty: 'Items cannot be empty.',
    MSG: 'MSG',
    RelatedRFQ: 'RelatedRFQ',
    CustomersQTN: "Customer's QTN",
    SubmitQTNToTheCustomer: 'Submit a QTN to the customer',
    ContactRFQ: 'Contact‘s RFQ',
  },
  /**报价 */
  qtn: {
    CreateNewQTN: "Create New QTN",
    SynchronizedRFQ: "Synchronized RFQ",
    ItemsInformation: "Items Information",
    RelatedPersonalRFQ: "Related Personal RFQ",
    RelatedPublicRFQ: "Related Public RFQ",
    RelatedMyRFQ: "Related My RFQ",
    sendTheQuotationToTheSupplier:
      "Are you sure you want to send the quotation to the supplier?",
    RelatedContactsRfq: "Related Contacts RFQ",
    addtoSalesOrder: "Add To Sales Order",
    PleaseSelectRFQ: 'Please Select RFQ'
  },
  /*公用*/
  com: {
    id: 'ID',
    add: 'Add',
    new: 'New',
    edit: 'Edit',
    confirm: 'Confirm',
    Submit: 'Submit',
    close: "Close",
    saveAndNew: 'Save And New',
    save: "Save",
    cancel: "Cancel",
    reset: 'Reset',
    del: 'Delete',
    print: 'Print',
    yes: 'Yes',
    no: 'No',
    Loading: 'Loading...',
    noMore: 'No more',
    noData: 'NO Data',
    information: 'Information',
    index: 'Index',
    select: 'Please Select',
    enter: 'Please Enter',
    enterTowDecimal: '0 or positive with max 2 decimal places',
    integer100_en: 'Please enter an integer between 0 and 100',
    letterNum_en: 'Please enter letters and numbers',
    searchMember: 'Search the member',
    search: 'Search',
    dateFormat: 'MM/DD/YYYY',
    timeFormat: 'MM/DD/YYYY HH:mm:ss',
    minuteFormat: 'MM/DD/YYYY HH:mm',
    startPlaceholder: 'Start date',
    To: 'To',
    endPlaceholder: 'End date',
    copySuccess: 'Successfully Copied ',
    copyError: 'Copy Failed',
    delSuccess: 'Successfully edited',
    delError: 'Delete Failed',
    addSuccess: 'Successfully added',
    addError: 'Add Failed',
    editSuccess: 'Successfully edited',
    editError: 'Editing failed',
    saveSuccess: 'Successfully saved',
    saveError: 'Save Failed',
    handleSuccess: 'Operation successful',
    handleError: 'Operation failed',
    serverError: 'Server error, please try again',
    networkError: 'Please check the network',
    checkData: 'Please check the data',
    aHour: "One hour expiration",
    aWeek: "One week expiration",
    aMoom: "Expires in one month",
    aHalfYear: "Half Year Expiration",
    aYear: "Expiration of one year",
    FileSharing: "File sharing",
    fileName: "File name",
    password: "Password",
    noPassword: "No password",
    yesPassword: "Share via password",
    expirationTime: "Expiration time",
    createLink: "create link",
    passwordError: 'Password error',
    EenterPwd: 'Please enter the password',
    linkTime: 'Link has expired',
    link: 'Link',
    creationDate: 'Creation Date',
    keyWords: 'Key Words',
    Email: 'Email',
    Email_en: 'Enter The Email',
    Email_en1: 'Enter The Correct Email',
    exactSearch: 'Exact Search',
    notSelected: 'No items selected',
    selectAnItem: 'Select an item from Items to start using it.',
    NotExp: 'There is currently no data to export!',
    action: "Action",
    import: 'Import',
    export: 'Export',
    setting: 'Setting',
    details: 'Details',
    type: 'Type',
    size: "Size",
    length: 'Length',
    width: 'Width',
    height: 'Hight',
    weight: 'Weight',
    diameter: 'Diameter',
    creator: "Creator",
    //All
    allCountries: 'All countries or regions',
    allCities: 'All Cities',
    allStatus: 'All Statuses',
    allTypes: 'All Types',
    allVendors: 'All Vendors',
    allContacts: 'All Contacts',
    allCreators: 'All Creators',
    allModels: 'All Models',
    allAccounts: 'All Accounts',
    allWays: 'All Ways',
    allStages: 'All Stages',
    allPredictionTypes: 'All Prediction Types',
    allSources: 'All Sources',
    allProducts: 'All Products',
    allBrands: 'All Brands',
    //
    All: 'All',
    My: 'My',
    RFQ: 'RFQ',
    QTN: 'QTN',
    QTY: 'QTY',
    model: 'Model',
    Stage: 'Stage',
    Detail: 'Detail',
    History: 'History',
    ActionLogs: 'Action Logs',
    MSG: 'MSG',
    Selected: 'Selected',
    Time: 'Time',
    Days: 'Days',
    Months: 'Months',
    once: 'once',
    circulate: 'circulate',
    owner: 'Owner',
    vendor: 'Vendor',
    country: "Country/Region",
    country_se: 'Select The Country/Region',
    resTime: 'Request timeout, please check the network!',
    res404: 'The network request does not exist!',
    res500: 'Internal server error!',
    resOther: 'Unknown exception occurred, exception information: ',
    markReadFailed: 'Mark read failed!',
    contact: "Contact",
    account: 'Account',
    account_se: 'Please select the Account',
    contact_se: 'Please select the Contact',
    city: 'City',
    city_en: 'Enter The City',
    zip: 'Zip',
    zip_en: "Enter The Zip",
    street: 'Street',
    street_en: 'Enter The Street',
    description: 'Description',
    description_en: 'Enter The Description',
  },
  //售后
  AfterSale: {
    AfterSale: 'After-sales',
    AfterSaleOrder: ' After-sales Orders',
    All: 'All',
    My: 'My',
    PleaseChooseAndCheckItems: 'Please choose and check items',
    SaveSuccess: "Saved Successfully",
    OrderNoAfterSale: 'This order can not be built After-Sales',
    Commission: 'Commission',
    Responsible: 'Responsible',
    VendorContact: 'Vendor Contact',
    AccountContact: 'Account Contact',
    Search_AllCountries: "All Countries or regions",
    Search_AllContacts: "All Contacts",
    Search_AllStatus: "All Statuses",
    Search_Models: "Models",
    Search_AllKeyword: "Owner/Creator/After-sales order ID",
    placeholderContacts: "Contacts",
    placeholderVendor: "Vendor",

    placeholderStatus: "Status",
    StartDate: "Start Date",
    EndDate: "End Date",
    NewAfterSale: "Create New After-sales",
    EditAfterSale: "Edit The After-sales",
    SelectTheType: "Select The Type",
    OrderInformation: "Order Information",
    PleaseSelectOrder: "Please select the order ID",
    Remarks: "Remarks",
    BankSlip: "Bank Slip",
    Purchase: "Purchase",
    Sale: "Sale",
    PurchaseOrder: "Purchase Order",
    SaleOrder: "Sales Order",
    Refunds: "Refund",
    ReturnsandRefunds: "Return and Refund",
    ReturnsandRefundsInformation: "Return and Refund Information",
    Type: "Type",
    //售后列表
    SaleList_OrderType: "Order Type",
    SaleList_AfterSaleType: "After-sales Type",
    SaleList_OrderId: "Order ID",
    SaleList_Owner: "Owner",
    SaleList_Status: "Status",
    SaleList_Creator: "Creator",
    SaleList_CreationDate: "Creation Date",
    SaleList_Action: "Action",

    //操作按钮
    Salebtn_New: "New",
    Salebtn_Edit: "Edit",
    Salebtn_Submit: "Submit",
    Salebtn_Delete: "Delete",
    Salebtn_Details: "Details",
    Salebtn_Save: "Save",
    Salebtn_Cancel: "Cancel",
    Salebtn_Close: "Close",
    //明细列表
    Details_Model: "Model",
    Details_Pi: "Order ID",
    Details_Brand: "Brand",
    Details_Condtion: "Condition",
    Details_Leading: "Leading",
    Details_Qty: "Total Qty",
    Details_Cost: "Cost",
    Details_Price: "Price",
    Details_Profit: "Profit（%）",
    Details_DiscountPrice: "Discount",
    Details_Tax: "Tax",
    Details_Total: "Total Amount",

    Details_ListCost: "List Cost",
    Details_ListPrice: "List Price",
    Details_ReturnedQuantity: "Returned Qty",
    Details_AmountRefunded: "Refunded Amount",

    Details_QuantityReturned: "Qty Return (Current)",
    Details_RefundAmount: "Amount Refund (Current)",
    Details_scale: "Ratio (Current)",
    Details_NegativeProfit: "Total Loss",
    Details_TotalRefund: "Total Refund",

    // 采购订单详细
    Details_QuantityInStorage: "In Stock",
    Details_QuantityOfThisStorage: "Qty Inbound (Current)",
    Details_NegativeProfitThisTime: "Loss (Current)",

    //提交售后
    Submit_Title: "Sure to submit the after sale order?",
    Submit_Tips: "Tips：",
    Submit_Commit1: "1.Cannot be edited after commit；",
    Submit_Commit2:
      "2.The financial personnel will refund according to the after sale order.",
    Submit_Scccessful: "After sale submission successful",

    //删除售后
    deleteSale_message: "Sure to delete the After-Sale order?",
    deleteSale_Scccessful: "Successfully deleted After-Sale",
    //验证信息
    refund_quantityPlease: "Please fill in the return quantity",
    refund_quantityMessage: "Cannot exceed the remaining returnable quantity",
    refund_amountPlease: "Please fill in the refund amount",
    refund_amountMessage: "Cannot exceed the remaining refundable amount",
    warehouse_numberPlease: "Please fill in the quantity of storage this time",
    warehouse_numberMessage:
      "The quantity of storage must not exceed the remaining quantity of storage",

    Fee: "Fee",
    PaymentFee: "PaymentFee",
    ShippingCost: "Shipping Cost",
    SubTotal: "Sub Total",
    GrandTotal: "Grand Total",
    AmountPayable: "Amount Payable ",
    AmountPaid: "Amount Paid",
    AmountRefunded: "Amount Refunded",
    GrossProfit: "Gross Profit",
    NegativeProfit: "Negative Profit",

    Draft: "Draft",
    PendingRefund: "Pending Refund",
    PartRefunded: "Partial Refund",
    Refunded: "Refunded",

    Specs: "Spec",

    Search: 'Search',
    Select: 'Select',
    AfterSalesTypeTip: 'Please Select The After-sales Type',
    OrderTypeTip: 'Please Select The Order Type',
    OrderNumberTip: 'Please Select The Order',

  },
  //SLACK
  slack: {
    channel: "Channel",
    createChannel: "Create Channel",
    privateLetter: "Private Letter",
    addFriends: "Add Friends",
    description: "Description",
    createUser: "CreateUser",
    exit: "Exit",
    remove: "Remove",
    newMessage: "NewMessage",
    message: "Message",
    file: "File",
    personnel: "Personnel",
    keywords: "Keywords",
    from: "From",
    to: "To",
    in: "In",
    view: "You are currently viewing",
    Channelname: "Channel Name",
    Rename: "Rename this channel",
    Starred: "Starred",
    Sales: "Sales",
    Contacts: "Contacts",
    CreatedBy: "Created By",
    Draft: "Draft",
    Quoting: "Quoting",
    PurchaseRecorded: "Purchase Recorded",
    SalesRecorded: "Sales Recorded",
    Completed: "Completed",
    Pending: "Pending",
    Models: "Models",
    RelatedPurchaseQTN: "Related Purchase QTN",
    RelatedContactQTN: "Related Contact’s QTN",
    Brand: "Brand",
    Condition: "Condition",
    Leading: "Leading",
    Cost: "Cost",
    Price: "Price",
    Quotedby: "Quoted by",
    Purchaser: "Purchaser",
    Vendor: "Vendor",
    VendorContacts: "Vendor Contacts",
    RelatedRFQ: "Related RFQ",
    PurchaseQTN: "Purchase QTN",
    ContactQTN: "Contact’s QTN",
    ContactRFQ: "Contact’s RFQ",
    SalesOrders: "Sales Orders",
    Itmes: "Itmes",
    RelatedQTN: "Related QTN",
    Fee: "Fee",
    Discount: "Discount",
    PaymentFee: "PaymentFee",
    ShippingCost: "Shipping Cost",
    Tax: "Tax",
    SubTotal: "Sub Total",
    GrandTotal: "Grand Total",
    Details: "Details",
    Type: "Type",
    Payment: "Payment",
    Address: "Address",
    PurchaseTasks: "Purchase Tasks",
    PurchaseOrders: "Purchase Orders",
    RelatedPurchaseTasks: "Related Purchase Tasks",
    RelatedPurchaseOrders: "Related Purchase Orders",
    Model: "Model",
    Qty: "Qty",
    Inventory: "Inventory",
    ListPrice: "List Price",
    Available: "Available",
    Occupy: "Occupy",
    ListCost: "List Cost",
    Profit: "Profit",
    Total: "Total",
    RelatedSalesOrder: "Related Sales Order",
    Owner: "Owner",
    DealStatus: "Deal Status",
    Fax: "Fax",
    Website: "Website",
    Name: "Name",
    Phone: "Phone",
    Email: "Email",
    AddressInformation: "Address Information",
    DescriptionInformation: "Description Information",
    RelatedInformation: "Related Information",
    Account: "Account",
    Level: "Level",
    OtherPhone: "OtherPhone",
    department: "department",
    DateOfBrith: "Date Of Brith",
    Selectobject: "Select a conversation object",
    Chatwithcontact: "Chat with contact",
    Chatwithpurchaser: "Chat with purchaser",
    Cancel: "Cancel",
    Next: "Next",
    Confirm: "Confirm",
    Create_a_channel: "Create a channel",
    MessageColumn: "Message Column",
    Replies: "Replies",
    createAccount:
      "The contact person has not created a system account. Please create an account first.",
    Edit: "Edit",
    RFQID: "RFQ ID",
    QTNID: "QTN ID",
    OrderID: "Order ID",
    PurchaseOrderID: "PurchaseOrder ID",
    ContactDetails: "Contact Details",
    VendorDetails: "Vendor Details",
    RFQ: "RFQ",
    QTN: "QTN",
    Order: "Orders",
    Searchobject: "Search the conversation object",
    adduser: "add user",
    About: "About",
    Member: "Member",
    delete: "Delete",
    ForwardMessage: "Forward Message",
    Orders: "Orders",
    HistoricalConversations: "Historical Conversations",
    noData: "No Data",
    YourChats: "Your Chats",
    Writemessage: 'Write a message',
    Video: "Video",
    voice: "Voice",
    Image: "Image",
    Selectobject: "Select a Conversation Object",
    LoginText: "Login",
    name: "Name",
    MyRFQtext: "My RFQ",
    MyQTNtext: "My QTN",
    MyOrders: "My Orders",
    CurrentRFQtext: "The Current RFQ",
    CurrentQTNtext: "The Current QTN",
    CurrentSalestext: "The Current Sale Order",
    CurrentPurchasetext: 'The Current Purchase Order',
    source: 'Source',
    Countrys: "Countrys",
    FormText: "Form",
    StatusText: "Status",
    AllRead: "All Read",
    BasicInformation: "Basic Information",
    CountryRegion: "Country/Region",
    DeliveryTime: "Delivery Time",
    ShippingFee: "Shipping Fee",
    Way: "Way",
    Doc: "Doc",
    AWB: "AWB",
    items: "items",
    Rate: "Rate",
    Weight: "Weight",
    Cartons: "Cartons",
    Carton: "Carton",
    Size: "Size",
    VolumeWeight: "Volume Weight",
    GrossWeigh: "Gross Weigh",
    PackingPictures: "Packing Pictures",
    Remarks: "Remarks",
  },
};